import { ConditionViewerItem, ConditionViewerTerm } from '@customerio/pluma-components/react';
import type { ScreenviewNode } from '../../types';
import { getIconForNode } from '../data-source-icon';
import { Times, Within } from '../condition-parts';

type ScreenviewConditionProps = { node: ScreenviewNode };

export function ScreenviewCondition({ node }: ScreenviewConditionProps) {
  const prefix = node.inverse ? 'Has not' : 'Has';
  return (
    <ConditionViewerItem icon={getIconForNode(node)}>
      {prefix} viewed a screen
      {node.screen != null ? (
        <>
          {' '}
          matching <ConditionViewerTerm>{node.screen}</ConditionViewerTerm>
        </>
      ) : null}
      <Times times={node.times} />
      <Within within={node.within} />
    </ConditionViewerItem>
  );
}
